import type { ComponentProps } from 'react'
import { Badge } from '@cocoonspace/ui/components/badge'
import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'
import { VideoIcon } from 'lucide-react'

export const VisioBadge = ({
	className,
	...props
}: ComponentProps<typeof Badge>) => {
	const { t } = useLingui()

	return (
		<Badge
			variant='secondary'
			size='sm'
			className={cn('gap-1 px-2', className)}
			{...props}
		>
			<VideoIcon className='!size-3 shrink-0' />
			{t`Visio`}
		</Badge>
	)
}
